module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/battery-charging-17193ae948a89564d7644589176b32ef.svg";